var _mask, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInactivejourney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_149_3526",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 26,
    height: 26,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    width: 26,
    height: 26
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 13C1 6.37258 6.37258 1 13 1C19.6274 1 25 6.37258 25 13C25 19.6274 19.6274 25 13 25C6.37258 25 1 19.6274 1 13Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 13C1 6.37258 6.37258 1 13 1C19.6274 1 25 6.37258 25 13C25 19.6274 19.6274 25 13 25C6.37258 25 1 19.6274 1 13Z",
    fill: "#EAEDFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 13M25 13M25 13M1 13M13 1M25 13M13 25M1 13M13 25V24C6.92487 24 2 19.0751 2 13H1H0C0 20.1797 5.8203 26 13 26V25ZM25 13H24C24 19.0751 19.0751 24 13 24V25V26C20.1797 26 26 20.1797 26 13H25ZM13 1V2C19.0751 2 24 6.92487 24 13H25H26C26 5.8203 20.1797 0 13 0V1ZM13 1V0C5.8203 0 0 5.8203 0 13H1H2C2 6.92487 6.92487 2 13 2V1Z",
    fill: "white",
    mask: "url(#path-1-outside-1_149_3526)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 9.6665L11.6666 16.3332L8.33325 12.9998",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactivejourney);
export default __webpack_public_path__ + "static/media/inactivejourney.c10c00e30f77d466ecdc0211a06db40d.svg";
export { ForwardRef as ReactComponent };